
import { granjaApi } from "../../api";
import { useGalponesStore } from "../../store";

import Swal from "sweetalert2";



export const startGalponXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/galpon/xid/${id}`);
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error)
    }
}



export const startListadoGalpones = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        const { data } = await granjaApi.get('/galpon', { params });
        useGalponesStore.setState({ totalGalpon: data.total });

        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const galponesXGranja = async( id ) => {
    try {
        const { data } = await granjaApi.get(`/galpon/xgranja/${id}`);
        return data.data;
    } catch (error) {
        Swal.fire('Error', error.response.data.msg, 'error');
        console.log(error);
    }
}




export const startSavingGalpones = async(galpon) => {
    try {
        if( galpon.id ){
            await granjaApi.put(`/galpon/${ galpon.id }`, galpon );
            Swal.fire('Exitoso', 'Galpon Actualizado', 'success');
        }else {
            await granjaApi.post('/galpon/new', galpon);
            Swal.fire('Exitoso', 'Galpon Creado', 'success');
            return true;
        }
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 


    
    



    // const deleteGranja = async( granja ) => {
    //     try {
    //         const { data } = await granjaApi.delete(`/granja/${ granja.id }`);
    //         if( data.ok ){
    //             dispatch( onDeleteGranja( data.granja ) );
    //             Swal.fire('Exitoso', 'Granja Eliminada', 'success');
    //         }
    //     } catch (error) {
    //         Swal.fire('Error', error.response.data.msg, 'error');
    //         console.log(error);
    //     }
    // }